import "./Home.css";

function Home() {
  return (
    <section className="hero">
      <div className="hero-container">

        <div className="hero-image">
          <img
            src="/profile3.jpg"
            alt="Mahad Nadeem"
          />
        </div>

        <div className="hero-content">
          <span className="hero-tag">
            CREATIVE VIDEO EDITOR
          </span>

          <h1>
            MAHAD <br />
            <span>NADEEM</span>
          </h1>

          <h3>Video Editor & Cinematographer</h3>

          <p>
            Professional Video Editor and Cinematographer with
            experience creating engaging content for brands,
            social media campaigns and promotional videos.
          </p>

          <div className="hero-buttons">
            <a
  href="https://www.instagram.com/_mahad_nadeem"
  target="_blank"
  rel="noreferrer"
>
  <button className="primary-btn">
    View Showreel
  </button>
</a>

            <a href="/contact">
  <button className="secondary-btn">
    Contact Me
  </button>
</a>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Home;